import { cn } from '#app/utils/misc.tsx'

export default function ArrowButton(
	props: React.ComponentPropsWithoutRef<'button'>,
) {
	const { className, ...rest } = props
	return (
		<button
			{...rest}
			className={cn([
				`group flex w-fit flex-row place-items-center space-x-4 pr-6 font-semibold leading-[26px] text-green-200 sm:px-0`,
				props.className,
			])}
		>
			<div>{rest.children}</div>
			<div className="arrow-button relative">
				<img
					src="/assets/arrow.svg"
					alt="right arrow-button"
					className="h-[26px] w-[22px] transform object-right transition-all duration-300 ease-out group-hover:ml-5 group-hover:translate-x-[1px]"
				/>
			</div>
		</button>
	)
}
